import { action } from "typesafe-actions";
import { DataActionTypes, FileProperties } from "./types";
import { ProviderFile } from "fileParsing/types";
import { clearLastFilename } from "@store/fileParsing/actions";
import { AppDispatch } from "index";

export function addNewData(fileProperties: FileProperties, providerId: string, workerId: string) {
  return (dispatch: AppDispatch) => {
    //dispatch(updateSubcategories());
    dispatch(
      action(DataActionTypes.ADD_DATA, {
        fileProperties,
        providerId,
        workerId,
      }),
    );
  };
}
export function updateData(exportId: number, id: number, data: ProviderFile) {
  return (dispatch: AppDispatch) => {
    dispatch(
      action(DataActionTypes.UPDATE_DATA, {
        exportId,
        fileId: id,
        data,
      }),
    );
  };
}
export function updateProperties(
  exportId: number,
  providerName: string,
  author: string,
  url: string,
  helpEn: string[],
  helpDe: string[],
) {
  return (dispatch: AppDispatch) => {
    dispatch(
      action(DataActionTypes.UPDATE_PROPERTIES, {
        exportId,
        providerName,
        author,
        url,
        helpEn,
        helpDe,
      }),
    );
  };
}
export function removeData(exportId: number) {
  return (dispatch: AppDispatch) => {
    dispatch(action(DataActionTypes.REMOVE_DATA, { exportId }));
    dispatch(clearLastFilename());
  };
}
export function switchActive(exportId: number) {
  return (dispatch: AppDispatch) => {
    dispatch(action(DataActionTypes.SWITCH_ITEM, exportId));
  };
}
export function renameExport(exportId: number, newName: string) {
  return (dispatch: AppDispatch) => {
    dispatch(action(DataActionTypes.RENAME_EXPORT, { exportId, newName }));
  };
}
export function setSensitivity(exportId: number, fileId: number, index: number, value: number) {
  return (dispatch: AppDispatch) => {
    dispatch(
      action(DataActionTypes.SET_PRIVACY_SENSITIVITY, {
        exportId,
        fileId,
        index,
        value,
      }),
    );
  };
}
